<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28.3 38.86" :class="sizeClass">
    <path class="cls-1" d="M24.91,0H3.39C1.52,0,0,1.52,0,3.39v34.18c0,.93.96,1.56,1.81,1.18l10.28-5.52c1.32-.58,2.82-.58,4.13,0l10.28,5.52c.85.37,1.81-.25,1.81-1.18V3.39c0-1.87-1.52-3.39-3.39-3.39Z"/>
  </svg>
</template>

<script>
import { defineComponent, computed } from 'vue'

export default defineComponent({
  props: {
    size: {
      type: String,
      default: 'default'
    }
  },
  setup(props) {
    const sizeClass = computed(() => {
      switch (props.size) {
        case 'lg':
          return 'lg'
        case 'sm':
          return 'sm'
        default:
          return 'size'
      }
    })

    return {
      sizeClass
    }
  }
})
</script>

<style lang="scss" scoped>
.size {
  width: 1em;
  height: 1em;
  fill: currentColor;
}
.lg {
  width: 1.25em;
  height: 1.25em;
  fill: currentColor;
}
.sm {
  width: 0.85em;
  height: 0.85em;
  fill: currentColor;
}
</style>
